import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Image } from 'antd';
import { CustomTitle } from '../../../components';
import cbplogo from '../../../assets/images/us-cbp-logo.png';

interface CustomsContactProps {
  airportName: string;
  iataCode: string;
}

const CustomsContact: React.FC<CustomsContactProps> = ({
  airportName,
  iataCode,
}) => {
  const navigate = useNavigate();

  return (
    <Card
      className='airline-card'
      onClick={() =>
        navigate(`/airport-list/${iataCode}/customs`, {
          state: { airportName, iataCode },
        })
      }
    >
      <CustomTitle
        className='airline-name'
        text='Customs'
        fontSize='18px'
        fontWeight='700'
        lineHeight='24px'
        color='var(--text-primary)'
        marginBottom='0'
      />
      <Image
        className='airline-img zl-custom-img'
        src={cbplogo}
        preview={false}
        alt='US CBP Logo'
        style={{ width: '100%' }}
      />
    </Card>
  );
};

export default CustomsContact;
